

























import { Component, Prop, Model, Emit, Vue } from "vue-property-decorator";

@Component
export default class InputImageTextBox extends Vue {
  @Model("change", { type: String }) selected!: string;
  @Prop({ required: true }) private answerId!: string;
  @Prop() private title!: string;
  @Prop() private image!: string;

  get isActive() {
    return this.answerId == this.selected;
  }

  @Emit("change")
  private onClick(): string {
    return this.answerId;
  }

  get customVuexStyles() {
    return {
      "--font-main": this.$store.state.globalCss.font.fontName,
      "--bg-color-active": this.$store.state.globalCss.colors.inputImageTextBox
        .backgroundColorActive,
      "--bg-color-inactive": this.$store.state.globalCss.colors
        .inputImageTextBox.backgroundColorInactive,
      "--color-active": this.$store.state.globalCss.colors.inputImageTextBox
        .colorActive,
      "--color-inactive": this.$store.state.globalCss.colors.inputImageTextBox
        .colorInactive
    };
  }
}
